import { isEmptyEntity } from '@app/utils'

import type { FiltersParams } from '@app/types/filter'

export const updateFiltersByKey = (prev: FiltersParams | null, key: string, value: unknown): object => {
  const validValue = isEmptyEntity(value) ? undefined : value

  if (!prev) return { [key]: validValue }

  return { ...prev, [key]: validValue }
}

export const getCollapseTitle = (isFiltersShow: boolean): string => `${isFiltersShow ? 'Скрыть' : 'Показать'} фильтры`
